module.exports = __webpack_public_path__ + "static/media/l3.54507b67.png";